import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useState, useRef , useEffect} from 'react';
import {isMobileOnly} from 'react-device-detect';
import { remove, uniq, filter, forEach, findIndex } from 'lodash';
import Slider from "react-slick";
import CheckBtn from '../common/button/CheckBtn';
import { reqEsBrandStep3BrandNum } from '../../modules/es/esMyModule';
import TagBtnMy from '../../components/common/button/TagBtnMy';

const MyEsBrandCatePopupBlock = styled.div`
    position: fixed;
    //background-color: rgba(17, 17, 17, 0.3);
    
    z-index: 100;
    ${isMobileOnly?`
    width: 100vw; 
    `:`
    width: 100%;
    height: 100%;
    `};
    
    ${isMobileOnly?`
    bottom: 0;
    transform: translateY(100vh);
    transition: transform 0.3s ease,opacity 0.3s ease;
    `:`
    top: 0;
    //left: -100%;
    transform: translateX(-100%);
    transition: transform 0.3s ease,opacity 0.3s ease;
    width: 100%;
    `};

    .close-pop {
        ${isMobileOnly?`
        height: calc(100vh - 510px);
        width: 100wh;  
        `:`
        //height: 100vh;
        width: calc(100% - 435px);
        `};
    }

    &.active {
        //display: block;
        
        ${isMobileOnly?`
        transform: translateY(0px);
        height: 100vh; 
        `:`
        transform: translateX(0);
        width: 100%;
        `};
    }

    &.active-no {
        
        ${isMobileOnly?`
        transform: translateY(100vh);
        //height: 0vh;
        height: 100vh;
        `:`
        transform: translateX(-100%);
        //height: 0vh;
        width: 100%;
        `};
    }

    &.hide {
        display:none;
    }

    .cate {
        
    }

`;

const MyEsBrandCatePCPopupContainerBlock = styled.div`
    .left_con {
        height: 100vh;
        background-color: #ffffff;
        float: left;
        width: 435px;
        //overflow: scroll;

        .top_block {
            height: 183px;
            width: 100%;
            background-color: #ffffff;
            position: relative;
            z-index: 102;

            .close_btn {
                margin-top: 40px;
                margin-left: 375px;
                width: 36px;
                height: 36px;
                background: url(/assets/images/icon/pp_btn_delete.png) center center/auto no-repeat;
                //position: fixed;
                background-size: 14px 14px;
            }

            .title {
                ${isMobileOnly?`
                font-size: 16px;
                text-align: center;
                margin-bottom: 20px; 
                position: relative;
                `:`
                font-size: 18px;
                margin-bottom: 40px; 
                position: relative;
                padding-left: 40px;
                `};
        
                font-weight: bold;
                height: 24px;
                
            }
            .back {
                ${isMobileOnly?`
                top: -7px;
                left: -4vw;
                `:`
                top: -78px;
                left: 20px;
                padding-left: 40px;
                `};
                width: 36px;
                height: 36px;
                position: absolute;
                
                background: url(/assets/images/icon/back_btn.svg) center center/auto no-repeat;
            }
        }
        
    }

    .right_con {
        float: left;
        height: 100vh;
        width: calc(100% - 435px);
        .continue {
            font-size: 52px;
            font-weight: normal;
            line-height: 100vh;
            color: #ffffff;
            margin-left: 60px;
            font-family: 'Dancing Script',cursive;
        }
    }
`;

const MyEsBrandCatePopupContainerBlock = styled.div`
    ${isMobileOnly?`
    height: 510px;
    `:`
    //height: 650px;
    `};
    
    color: #111111;
    position: relative;
    //top: calc(100vh - 500px);

    .top-blank {
        height: 10px;
        width: 100vw;
    }
    .top-bar {
        border-radius: 4px;
        background-color: #ffffff;
        width: 50px;
        height: 8px;
        margin: 0 auto;
        margin-bottom: 10px;
    }
    .container {
        ${isMobileOnly?`
        background-color: #ffffff;
        border-top-right-radius: 12px;
        border-top-left-radius: 12px;
        padding: 26px 4vw 0;
        height: 490px;
        `:`
        padding: 0px 40px 0px;
        height: calc(100vh - 340px);;
        overflow: auto;
        `};
    }

    .title {
        ${isMobileOnly?`
        font-size: 16px;
        text-align: center;
        margin-bottom: 20px; 
        position: relative;
        `:`
        font-size: 18px;
        margin-bottom: 40px; 
        position: fixed;
        top: 116px;
        `};

        font-weight: bold;
        height: 24px;
        
    }

    .back {
        ${isMobileOnly?`
        top: -7px;
        left: -4vw;
        `:`
        top: -78px;
        left: -14px;
        `};
        width: 36px;
        height: 36px;
        position: absolute;
        
        background: url(/assets/images/icon/back_btn.svg) center center/auto no-repeat;
    }
    
    .cate1 {
        ${isMobileOnly?`
        font-size: 14px;
        margin-bottom: 16px;
        `:`
        font-size: 18px;
        margin-bottom: 20px;
        `};
        cursor: pointer;
        font-weight: normal;
        height: 20px;
        line-height: 20px;
        position: relative;
        
        ::after {
            content: '';
            display: inline-block;
            width: 5px;
            height: 10px;
            position: absolute;
            ${isMobileOnly?`
            right: 4vw;
            `:`
            right: 40px;
            `};
            
            margin-top: 5px;
            background: url(/assets/images/icon/arrow_right.svg) center center/cover no-repeat;
            -webkit-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            transform: rotate(360deg);
    }

    .num {
        ${isMobileOnly?`
        font-size: 13px;
        margin-left: 4px;
        `:`
        font-size: 20px;
        margin-left: 10px;
        `};
        
        font-weight: 500;
        color: #fc7a35;
        //line-height: 2;
    }

`;

const EsCate2Block = styled.div`
    ${isMobileOnly?`
    font-size: 14px;
    margin-bottom: 16px;
    `:`
    font-size: 18px;
    margin-bottom: 20px;
    `};
    cursor: pointer;
    font-weight: normal;
    height: 20px;
    line-height: 20px;
    position: relative;

    color:${props => props.active? '#111111' : '#999999'};

    ::after {
        content: '';
        display: ${props => props.active? 'inline-block' : 'none'};
        width: 12px;
        height: 9px;
        position: absolute;
        ${isMobileOnly?`
        right: 4vw;
        `:`
        right: 40px;
        `};
        margin-top: 5px;
        background: url(/assets/images/icon/es_check.svg) center center/cover no-repeat;
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
}
`;

const EsTopCateBlcok = styled.div`
    ${isMobileOnly?`
    margin-left: -4vw;
    width: 100vw;
    overflow: scroll;
    `:`
    width: 100%;
    overflow: auto;
    overflow-y: hidden;
    `};
    
    ::-webkit-scrollbar {
        ${isMobileOnly?`
         
        `:`
        height: 4px
        `};
        
      }

    ::-webkit-scrollbar-thumb {
        ${isMobileOnly?`
         
        `:`
        border-radius: 2px;
        background-color: #ececec;
        `};
        
      }

    height: 34px;

    .cate-container {
        ${isMobileOnly?`
        padding-bottom: 10px;
        `:`
        display: flex;
        white-space: nowrap;
        
        `};
        
        width: max-content;       
    }

    .top-cate {
        margin-right: 6px;
        //margin-bottom: 10px;
        float: left;
    }
    .top-cate:last-child {
        ${isMobileOnly?`
        margin-right: 4vw;
        `:`
        `};
    }

    .top-cate:first-child {
        ${isMobileOnly?`
        margin-left: 4vw;
        `:`
        `};
    }
`;

const BottomBlock = styled.div`
    ${isMobileOnly?`
    position:fixed;
    width: 100vw;
    padding: 20px 4vw;
    display: block;
    `:`
    position:absolute;
    width: 435px;
    padding: 20px 40px 40px;
    
    `};
    //margin: 0 4vw; 
    
    //display: block;
    
    bottom:0;
    z-index: 101;
    font-size: 13px;
    line-height: 1.46;
    font-weight: normal;
    //border-top: solid 1px #cccccc;
    
    
    background-color: #ffffff;
    //height: 145px;

    .line {
        background-color: #cccccc;
        height: 1px;
        
        ${isMobileOnly?`
        margin-left: -4vw;
        width: 100vw;
        `:`
        width: 100%;
        `};
    }

    .bottom-container {
        position: relative;
    }
    .list {
        padding: 0 18px 0 16px;
    }
    

    .pre {
        border-radius: 4px;
        background-color: #ececec;
        background: url(/assets/images/icon/refresh.png) center center/auto no-repeat, #ececec;
        text-align: center;
        color: #333333;
        height: 52px;
        width: 18%;
        float: left;
        background-size: 17px 17px;
    }

    .apply {
        border-radius: 4px;
        background-color: #111111;
        text-align: center;
        color: #ffffff;
        height: 52px;
        width: 79%;
        float: right;
        .num {
            font-weight: bold;
        }
    }
`;

const MyEsBrandCatePopup = ({info, active, handleClosePopup, cate3Step, handleCategory}) => {
    const refbox = useRef(null);
    const refContainer = useRef(null);
    const [selId, setSelId] = useState(-1);
    const [cate2, setCate2] = useState([]);
    const [arrCate3Step, setArrCate3Step] = useState([]);
    const [cateItems, setCateItems] = useState([]); //id + name + on
    const dispatch = useDispatch();
    const [startY, setStartY] = useState(0);
    const [moveY, setMoveY] = useState(0);

    const { categoryItems, esMyBrandCate1Step, esBrandNumStep3} = useSelector(
        ({ cateItemsReducer, esMyReducer }) => ({
            categoryItems: cateItemsReducer.cateItems,
            esMyBrandCate1Step: esMyReducer.esMyBrandCate1Step,
            esBrandNumStep3: esMyReducer.esBrandNumStep3,
        })
    );

    useEffect(() => {
        const handleEnd = (e) => {
            if(isMobileOnly) {
                if(refbox.current.getBoundingClientRect().top > 100) {
                    refbox.current.classList.add('hide');
                } else {
                    refbox.current.classList.remove('hide');
                }
            }
            //console.log("transitionend = " + JSON.stringify(refbox.current.getBoundingClientRect()));

        }

        document.addEventListener("transitionend", handleEnd);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("transitionend", handleEnd);
        };
    }, []);

    useEffect(() => {
        if(refbox && refbox.current) {
            if(active) {
                refbox.current.classList.remove('hide');
                refbox.current.classList.remove('active-no');
                setTimeout(() => {
                    refbox.current.classList.add('active');
                }, 10);

                if(isMobileOnly) {
                    document.body.style.overflow = 'hidden';
                    document.body.style.position= 'fixed';
                } else {
                    document.body.style.overflow = 'hidden';
                }

            } else {
                refbox.current.classList.remove('active');
                refbox.current.classList.add('active-no');

                if(isMobileOnly) {
                    document.body.style.overflow = 'unset';
                    document.body.style.position= 'relative';
                } else {
                    //document.body.style.overflow = 'auto';
                    document.body.removeAttribute('style')
                }

            }
        }

        if(active) {
            let arr = [];
            Object.assign(arr,cate3Step);
            setArrCate3Step(arr);
        }

    }, [active]);

    useEffect(() => {

        if (categoryItems) {
            let arr = [];
            forEach(categoryItems, (curobj, index) => {
                let cate1Id = curobj.id;
                forEach(curobj.cate2, (cate2, index) => {
                    let cateid = cate1Id*100 + cate2.id*1;
                    let cateItem = {id:cateid, name:cate2.cate_name, on:false};
                    arr.push(cateItem);
                });
            });

            if(cate3Step) {
                forEach(arr, (cate, index) => {
                    let idx = findIndex(cate3Step, (curitem) => {
                        //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
                        return curitem*1 === cate.id*1;
                    })

                    if(idx >= 0) {
                        cate.on = true;
                    }  else {
                        cate.on = false;
                    }

                });
            }
            //console.log("arr = " + JSON.stringify(arr));
            setCateItems(arr);

        }

    }, [categoryItems]);

    useEffect(() => {
        //console.log("esMyBrandCate3Step = " + JSON.stringify(esMyBrandCate3Step));
        //console.log("cateItems = " + JSON.stringify(cateItems));
        //console.log("arrCate3Step = " + JSON.stringify(arrCate3Step));
        if(arrCate3Step && cateItems.length>= 0) {
            let arr = [];
            Object.assign(arr, cateItems);

            if(arr.length === 0) {
                forEach(categoryItems, (curobj, index) => {
                    let cate1Id = curobj.id;
                    forEach(curobj.cate2, (cate2, index) => {
                        let cateid = cate1Id*100 + cate2.id*1;
                        let cateItem = {id:cateid, name:cate2.cate_name, on:false};
                        arr.push(cateItem);
                    });
                });
            }

            forEach(arr, (cate, index) => {
                let idx = findIndex(arrCate3Step, (curitem) => {
                    //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
                    return curitem*1 === cate.id*1;
                })

                if(idx >= 0) {
                    cate.on = true;
                } else {
                    cate.on = false;
                }
            });

            //console.log("arr22 = " + JSON.stringify(arr));
            setCateItems(arr);
        }

        dispatch(reqEsBrandStep3BrandNum(arrCate3Step));

    }, [arrCate3Step]);

    useEffect(() => {
        //console.log("change cate3Step = " + JSON.stringify(cate3Step))
        //if(cate3Step) {
            let arr = [];
            Object.assign(arr,cate3Step);
            setArrCate3Step(arr);
        //}
    }, [cate3Step]);

    const handelFirstClick = (id) => {
        let idx = findIndex(categoryItems, (curitem) => {
            //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
            return curitem.id*1 === id*1;
        })

        if(idx >=0 ) {
            setCate2(categoryItems[idx].cate2);
        }
        setSelId(id);
    }

    const handleSecondClick = (cateid) => {
        let arr = [];
        Object.assign(arr,arrCate3Step);

        if(isAllCate2()) {
            forEach(cate2, (cate, index) => {
                const _cateid = selId*100 + cate.id*1;
                remove(arr, (curitem) => {
                    return curitem*1 === _cateid*1;
                });
            });

            //전체 선택
            if(cateid < 0) {

            } else {
                arr.push(cateid)
            }
            setArrCate3Step(arr);
        }
        else {
            //전체 선택
            if(cateid < 0) {
                forEach(cate2, (cate, index) => {
                    const _cateid = selId*100 + cate.id*1;
                    remove(arr, (curitem) => {
                        return curitem*1 === _cateid*1;
                    });
                });

                forEach(cate2, (cate, index) => {
                    const _cateid = selId*100 + cate.id*1;
                    arr.push(_cateid)
                });

                setArrCate3Step(arr);
            } else {
                let idx = findIndex(arrCate3Step, (curitem) => {
                    //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
                    return curitem*1 === cateid*1;
                })

                if(idx >= 0) {
                    if(arr.length > 1) {
                        remove(arr, (curitem) => {
                            return curitem*1 === cateid*1;
                        });
                    }
                } else {
                    arr.push(cateid)
                }

                setArrCate3Step(arr);
            }
        }

    }

    const handleCateClick = (cateid) => {

    }

    const handleCateDelClick = (cateid) => {
        let arr = [];
        Object.assign(arr,arrCate3Step);
        if(arr.length > 1) {
            remove(arr, (curitem) => {
                return curitem*1 === cateid*1;
            });
            setArrCate3Step(arr);
        }
    }

    const getSecondTitle = () => {
        let idx = findIndex(categoryItems, (curitem) => {
            //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
            return curitem.id*1 === selId*1;
        })
        if(idx >=0 ) {
            return categoryItems[idx].cate_name;
        }
    }

    const isAllCate2 = () => {
        let value = true;

        forEach(cate2, (cate, index) => {
            const _cateid = selId*100 + cate.id*1;

            let idx = findIndex(arrCate3Step, (curitem) => {
                //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
                return curitem*1 === _cateid*1;
            })

            if(idx >= 0) {

            } else {
                value = false;
            }
        });

        return value;
    }

    const getActive = (cateid) => {
        if(cateid < 0) {

            return isAllCate2();

        } else {
            if(isAllCate2()) {
                return false;
            }

            let idx = findIndex(arrCate3Step, (curitem) => {
                //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
                return curitem*1 === cateid*1;
            })

            if(idx >= 0) {
                return true;
            } else {
                return false;
            }
        }
    }

    const onClick = (e) => {
        e.stopPropagation();
        if(handleClosePopup !== null && handleClosePopup !== undefined) {
            handleClosePopup();
            setSelId(-1);
        }

    }

    const onClickContainer = (e) => {

    }

    const handdleBack = () => {
        setSelId(-1);
    }

    const handleRefresh = (e) => {
        setArrCate3Step(esMyBrandCate1Step);
    }

    const handleApply = (e) => {
        if(handleCategory !== null && handleCategory !== undefined) {
            handleCategory(arrCate3Step);
            if(handleClosePopup !== null && handleClosePopup !== undefined) {
                handleClosePopup();
                setSelId(-1);
            }
        }
    }

    const get1stCount = (id) => {
        let num = 0;

        forEach(arrCate3Step, (curobj, index) => {
            if(Math.floor(curobj/100) === id*1) {
                num++;
            }
        });

        if(num > 0) {
            return num;
        } else {
            return " "
        }
    }

    const  touchX = (event) => {
        if ("touches" in event && event.touches.length >= 1) {
            const { clientX, clientY } =
            "touches" in event ? event.touches[0] : event;

            return clientX;
          }

          return;
    }

    const touchY = (event) => {
        //return;
        if ("touches" in event && event.touches.length >= 1) {
            const { clientX, clientY } =
            "touches" in event ? event.touches[0] : event;

            return clientY;
        }
        return;
    }

    const touchCancel = (e) => {

    }

    const touchEnd = (e) => {
        if(isMobileOnly && startY > 0) {
            //if(moveY - startY > 70) {
                if(handleClosePopup !== null && handleClosePopup !== undefined) {
                    handleClosePopup();
                    setSelId(-1);
                }
            //}
        }

        setMoveY(0);
        setStartY(0);
    }

    const touchMove = (e) => {
        if(isMobileOnly && startY > 0) {
            let moveY = touchY(e);
            setMoveY(moveY);
        }
    }

    const touchStart = (e) => {
        if(isMobileOnly && refContainer && refContainer.current){
            let startY = touchY(e);
            console.log('topY = ' + refContainer.current.getBoundingClientRect().top)

            if(startY - refContainer.current.getBoundingClientRect().top < 40) {
                setStartY(startY);
            }
        }
    }

    if(categoryItems === null || categoryItems&&categoryItems.length < 1) {
        return <div/>
    }

    return (
        isMobileOnly?
        <MyEsBrandCatePopupBlock  ref={refbox}>
            <div className="close-pop" /* onMouseDown = {onClick} onTouchStart={onClick}  */onClick={onClick}>&nbsp;</div>
            <MyEsBrandCatePopupContainerBlock ref={refContainer} onClick={touchStart} onTouchStart={touchStart} onTouchMove={touchMove} onTouchEnd={touchEnd} onTouchCancel={touchCancel}>
                <div className="top-blank "/>
                <div className="top-bar" ></div>
                {selId < 0 ?
                    <div className="container" onClick={onClickContainer}>
                        <div className="title">카테고리</div>
                        {
                            categoryItems.map((cateitem,index) => {
                                    const cateid = cateitem.id;
                                    const name = cateitem.cate_name;
                                    return (
                                    <div key={cateid} className="cate1" onClick={()=>handelFirstClick(cateid)}>{name}<span className="num">{get1stCount(cateid)}</span></div>
                                    )

                                })
                        }
                    </div>
                    :
                    <div className="container" onClick={onClickContainer}>
                    <div className="title"><button className="back" onClick={handdleBack}/>{getSecondTitle()}</div>
                        <EsCate2Block key={-1} active={getActive(-1)} onClick={()=>handleSecondClick(-1)}>전체</EsCate2Block>
                        {
                            cate2.map((cateitem,index) => {
                                    const cateid = selId*100 + cateitem.id*1;
                                    const name = cateitem.cate_name;
                                    return (
                                        <EsCate2Block key={cateid} active={getActive(cateid)} onClick={()=>handleSecondClick(cateid)}>{name}</EsCate2Block>
                                    )

                                })
                        }
                    </div>
                }
                <BottomBlock>
                    <div className="line margin_b-20" >&nbsp;</div>
                    <EsTopCateBlcok className=" margin_b-10" >
                        <div className="cate-container clearfix">
                        {
                            cateItems.map((cateitem,index) => {
                                    const cateid = cateitem.id;
                                    const name = cateitem.name;
                                    if(cateitem.on) {
                                        return (
                                            <div key={cateid} className="top-cate">
                                                <TagBtnMy
                                                    active={true}
                                                    float='left'
                                                    onClick={handleCateClick}
                                                    onDelClick={handleCateDelClick}
                                                    text={name} isSmall={true} value={cateid}
                                                />
                                            </div>
                                        );
                                    }

                                })
                            }
                        </div>
                    </EsTopCateBlcok>
                    {
                        arrCate3Step&&arrCate3Step.length === 0?
                        <div><button className="pre" onClick={handleRefresh}></button><button className="apply">필요한 품목 선택하기</button></div>
                        :
                        <div><button className="pre" onClick={handleRefresh}></button><button className="apply" onClick={handleApply}><span className="num">{esBrandNumStep3&&(esBrandNumStep3.length)}</span>개 브랜드 보기</button></div>
                    }
                </BottomBlock>
            </MyEsBrandCatePopupContainerBlock>
        </MyEsBrandCatePopupBlock>
        :
        <MyEsBrandCatePopupBlock  ref={refbox}>
            <MyEsBrandCatePCPopupContainerBlock>
                <div className="left_con">
                    <div  className="top_block">
                    <button className="close_btn margin_b-40" onClick={onClick}></button>
                    {
                        selId < 0 ?
                        <div className="title">카테고리</div>
                        :
                        <div className="title"><button className="back" onClick={handdleBack}/>{getSecondTitle()}</div>
                    }
                    </div>
                    <MyEsBrandCatePopupContainerBlock ref={refContainer} onTouchStart={touchStart} onTouchMove={touchMove} onTouchEnd={touchEnd} onTouchCancel={touchCancel}>
                        {selId < 0 ?
                            <div className="container small_scroll" onClick={onClickContainer}>
                                {/* <div className="title">카테고리</div> */}
                                
                                {
                                    categoryItems.map((cateitem,index) => {
                                            const cateid = cateitem.id;
                                            const name = cateitem.cate_name;
                                            return (
                                            <div key={cateid} className="cate1" onClick={()=>handelFirstClick(cateid)}>{name}<span className="num">{get1stCount(cateid)}</span></div>
                                            )

                                        })
                                }
                            </div>
                            :
                            <div className="container small_scroll" onClick={onClickContainer}>
                            {/* <div className="title"><button className="back" onClick={handdleBack}/>{getSecondTitle()}</div> */}
                                <EsCate2Block key={-1} active={getActive(-1)} onClick={()=>handleSecondClick(-1)}>전체</EsCate2Block>
                                {
                                    cate2.map((cateitem,index) => {
                                            const cateid = selId*100 + cateitem.id*1;
                                            const name = cateitem.cate_name;
                                            return (
                                                <EsCate2Block key={cateid} active={getActive(cateid)} onClick={()=>handleSecondClick(cateid)}>{name}</EsCate2Block>
                                            )

                                        })
                                }
                            </div>
                        }
                        
                    </MyEsBrandCatePopupContainerBlock>
                    <BottomBlock>
                            <div className="line margin_b-20" >&nbsp;</div>
                            <EsTopCateBlcok className=" margin_b-10" >
                                <div className="cate-container clearfix">
                                {
                                    cateItems.map((cateitem,index) => {
                                            const cateid = cateitem.id;
                                            const name = cateitem.name;
                                            if(cateitem.on) {
                                                return (
                                                    <div key={cateid} className="top-cate">
                                                        <TagBtnMy
                                                            active={true}
                                                            float='left'
                                                            onClick={handleCateClick}
                                                            onDelClick={handleCateDelClick}
                                                            text={name} isSmall={true} value={cateid}
                                                        />
                                                    </div>
                                                );
                                            }

                                        })
                                    }
                                </div>

                            </EsTopCateBlcok>
                            {
                                arrCate3Step&&arrCate3Step.length === 0?
                                <div><button className="pre" onClick={handleRefresh}></button><button className="apply">필요한 품목 선택하기</button></div>
                                :
                                <div><button className="pre" onClick={handleRefresh}></button><button className="apply" onClick={handleApply}><span className="num">{esBrandNumStep3&&(esBrandNumStep3.length)}</span>개 브랜드 보기</button></div>
                            }
                        </BottomBlock>
                </div>
                <div className="right_con" onClick={onClick}>
                            <div className="continue">continue&gt;</div>
                </div>
            </MyEsBrandCatePCPopupContainerBlock>

        </MyEsBrandCatePopupBlock>
    );
};

export default MyEsBrandCatePopup;
